module.exports = __webpack_public_path__ + "static/media/luma-star-muted.e1b0cad3.svg";